/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { ParameterCombinationDto } from './ParameterCombinationDto';
import {
    ParameterCombinationDtoFromJSON,
    ParameterCombinationDtoFromJSONTyped,
    ParameterCombinationDtoToJSON,
} from './ParameterCombinationDto';

/**
 * 
 * @export
 * @interface ParameterCombinationTableDto
 */
export interface ParameterCombinationTableDto {
    /**
     * 
     * @type {Array<ParameterCombinationDto>}
     * @memberof ParameterCombinationTableDto
     */
    combinations?: Array<ParameterCombinationDto> | null;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof ParameterCombinationTableDto
     */
    possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {string}
     * @memberof ParameterCombinationTableDto
     */
    $type?: ParameterCombinationTableDtoTypeEnum;
}


/**
 * @export
 */
export const ParameterCombinationTableDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoParameterCombinationsParameterCombinationTableDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.ParameterCombinations.ParameterCombinationTableDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type ParameterCombinationTableDtoTypeEnum = typeof ParameterCombinationTableDtoTypeEnum[keyof typeof ParameterCombinationTableDtoTypeEnum];



/**
 * Check if a given object implements the ParameterCombinationTableDto interface.
 */
export function instanceOfParameterCombinationTableDto(value?: unknown): value is ParameterCombinationTableDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ParameterCombinationTableDtoTypeEnum)[0];
}

export function ParameterCombinationTableDtoFromJSON(json: any): ParameterCombinationTableDto {
    return ParameterCombinationTableDtoFromJSONTyped(json, false);
}

export function ParameterCombinationTableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParameterCombinationTableDto {
    if (json == null) {
        return json;
    }
    return {
        
        'combinations': json['combinations'] == null ? undefined : ((json['combinations'] as Array<any>).map(ParameterCombinationDtoFromJSON)),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ParameterCombinationTableDtoToJSON(value?: ParameterCombinationTableDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'combinations': value['combinations'] == null ? undefined : ((value['combinations'] as Array<any>).map(ParameterCombinationDtoToJSON)),
        'possibleActions': value['possibleActions'] == null ? undefined : ((value['possibleActions'] as Array<any>).map(PossibleActionDtoToJSON)),
        '$type': value['$type'],
    });
}

